"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const StyledMainContainer_1 = require("components/Dashboard/StyledMainContainer");
const ErrorFallback = ({ error }) => (react_1.default.createElement(StyledMainContainer_1.StyledMainContainer, null,
    react_1.default.createElement(polaris_1.Banner, { status: 'critical', title: 'Oops! Something went wrong.' },
        react_1.default.createElement("p", null, error.message))));
exports.default = ErrorFallback;
